import { useIdleTimer } from 'react-idle-timer';

const timeoutKey = 'custom-idle-override-timeout';

export const useApplicationIdleHandler = (config: {
    maxTimeoutInMinutes: number;
    signout: () => void;
    userLoggedOut: boolean;
    setApplicationReloadUrl: () => void;
}) => {
    let maxTimeoutInMinutes = config.maxTimeoutInMinutes;

    if (window.sessionStorage.getItem(timeoutKey)) {
        const restoredTimeoutInMinutes = Number(window.sessionStorage.getItem(timeoutKey));

        // Restored timeout must be less than the max timeout of 15 mins, they can shorten it.
        // but not extend it.
        if (!isNaN(restoredTimeoutInMinutes) && restoredTimeoutInMinutes < config.maxTimeoutInMinutes) {
            console.log(`Custom idle timeout set to ${restoredTimeoutInMinutes} minute(s)`);
            maxTimeoutInMinutes = restoredTimeoutInMinutes;
        }
    }

    const handleOnIdle = (event: Event) => {
        if (!config.userLoggedOut) {
            console.log(`User has been idle for ${maxTimeoutInMinutes} minute(s). And will be signed out.`);
            config.setApplicationReloadUrl();
            config.signout();
        } else {
            console.log('User is currently on log out screen. And will not be logged out again');
        }
    };

    const handleOnActive = (event: Event) => {
        // Left in for future debugging
        // console.log('user is active', event);
        // console.log('time remaining', getRemainingTime());
    };

    const handleOnAction = (event: Event) => {
        // Left in for future debugging
        // console.log('user did something', event);
    };

    const { getRemainingTime, getLastActiveTime } = useIdleTimer({
        timeout: 1000 * 60 * maxTimeoutInMinutes,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnAction,
        debounce: 500
    });
};
